import React, { useState } from 'react';
import expedienteService from '../services/expedienteService';
import './Importacion.css';

const Importacion = () => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile.name.endsWith('.xlsx') || selectedFile.name.endsWith('.xls')) {
        setFile(selectedFile);
        setError('');
        setResult(null);
      } else {
        setError('Por favor selecciona un archivo Excel (.xlsx o .xls)');
        setFile(null);
      }
    }
  };

  const handleUpload = async () => {
    if (!file) {
      setError('Por favor selecciona un archivo primero');
      return;
    }

    setUploading(true);
    setError('');
    setResult(null);

    try {
      const data = await expedienteService.importExcel(file);
      setResult(data);
      setFile(null);
      document.getElementById('file-input').value = '';
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al importar');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="importacion-container" data-testid="importacion-page">
      <div className="importacion-header">
        <h1>Importar Expedientes</h1>
        <p>Carga un archivo Excel para importar múltiples expedientes</p>
      </div>

      {/* Instrucciones */}
      <div className="info-card">
        <h2>📌 Instrucciones de Importación</h2>
        <ul>
          <li>El archivo debe ser formato Excel (.xlsx o .xls)</li>
          <li>Asegúrate de que las columnas coincidan con el formato esperado</li>
          <li>Los expedientes duplicados (mismo Cédula + Contrato) serán actualizados</li>
          <li>Todos los expedientes importados tendrán estado "En espera" automáticamente</li>
          <li>El campo "Status" del Excel se usará como "Estatus Cliente"</li>
        </ul>
      </div>

      {/* Estructura */}
      <div className="structure-card">
        <h2>Estructura del Excel</h2>
        <div className="structure-grid">
          <div className="structure-group">
            <h3>Grupo: Información</h3>
            <ul>
              <li>Sede</li>
              <li>Nombre</li>
              <li>Apellido</li>
              <li>Contrato</li>
              <li>Cedula</li>
              <li>Telefono</li>
              <li>Email</li>
              <li>Modelo de contrato</li>
              <li>Status</li>
            </ul>
          </div>
          <div className="structure-group">
            <h3>Grupo: Finanzas</h3>
            <ul>
              <li>Valor Cuota</li>
              <li>Cantidad Cuota</li>
              <li>Pago Bs</li>
              <li>Pago Divisas</li>
              <li>Total Viejo</li>
              <li>Pago App</li>
              <li>Fecha del ultimo pago</li>
            </ul>
          </div>
          <div className="structure-group">
            <h3>Grupo: Producto</h3>
            <ul>
              <li>Modelo</li>
              <li>placa</li>
              <li>Mes de entrega</li>
              <li>año de entrega</li>
              <li>pago de seguro</li>
              <li>certificado</li>
              <li>factura</li>
            </ul>
          </div>
          <div className="structure-group">
            <h3>Grupo: Validación</h3>
            <ul>
              <li>Migrado</li>
              <li>revisado</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Upload Area */}
      <div className="upload-card">
        <div className="upload-area" onClick={() => document.getElementById('file-input').click()}>
          <div className="upload-icon">📄</div>
          <p className="upload-label">Click aquí para seleccionar un archivo Excel</p>
          <input 
            id="file-input" 
            type="file" 
            accept=".xlsx,.xls" 
            onChange={handleFileChange} 
            className="file-input-hidden" 
            data-testid="file-input" 
          />
          
          {file && (
            <div className="file-selected" onClick={(e) => e.stopPropagation()}>
              <p>✅ Archivo seleccionado: <strong>{file.name}</strong></p>
              <p className="file-size">Tamaño: {(file.size / 1024 / 1024).toFixed(2)} MB</p>
            </div>
          )}
        </div>

        {error && <div className="error-box">{error}</div>}

        <button onClick={handleUpload} disabled={!file || uploading} className="upload-btn" data-testid="upload-button">
          {uploading ? (
            <span className="upload-loading">
              <div className="spinner-small"></div>
              Importando...
            </span>
          ) : (
            'Importar Expedientes'
          )}
        </button>

        {result && (
          <div className="result-card" data-testid="import-result">
            <h3>✅ Importación Completada</h3>
            <div className="result-grid">
              <div className="result-item">
                <p className="result-label">Expedientes Creados</p>
                <p className="result-value result-created">{result.created}</p>
              </div>
              <div className="result-item">
                <p className="result-label">Expedientes Actualizados</p>
                <p className="result-value result-updated">{result.updated}</p>
              </div>
            </div>
            {result.errors && result.errors.length > 0 && (
              <div className="errors-section">
                <h4>Errores Encontrados ({result.total_errors}):</h4>
                <div className="errors-list">
                  {result.errors.map((err, idx) => (
                    <p key={idx}>Fila {err.row}: {err.error}</p>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Importacion;